import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
const GenericPageContainer = _ref => {
  let {
    rendering
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "module-group remove-padding-header"
  }, /*#__PURE__*/React.createElement(Placeholder, {
    name: "dot-generic-body",
    rendering: rendering
  }));
};
export default GenericPageContainer;